import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

enum ActionType {
  Revert = 'Revert',
  Reverse = 'Reverse'
}

@Component({
  selector: 'app-reversal-claim-dialog',
  templateUrl: './reversal-claim-dialog.component.html',
  styleUrls: [
    'reversal-claim-dialog.component.scss',
    '../../../../../../styles/global/_dialog-styles.scss'
  ]
})
export class ReversalClaimDialogComponent implements OnInit {
  readonly actionType = ActionType;

  heading: string;
  isPharmacyClaim: boolean;
  confirmRevertAction: boolean;
  confirmReverseAction: boolean;

  constructor(
    public dialogRef: MatDialogRef<ReversalClaimDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isPharmacyClaim = data?.isPharmacyClaim;
  }

  ngOnInit(): void {
    this.heading = 'How would you like to handle this Claim?';
  }

  onClickActionTypeSelected(actionType: ActionType): void {
    if (actionType === ActionType.Revert) {
      this.confirmRevertAction = true;
      this.confirmReverseAction = false; // 1 Button should be active at a time
    }
    else if (actionType === ActionType.Reverse) {
      this.confirmReverseAction = true;
      this.confirmRevertAction = false;
    }
  }

  onClickToggleIcons(event: MouseEvent, actionType: ActionType): void {
    event.preventDefault();
    event.stopPropagation();

    if (actionType === ActionType.Revert) {
      this.confirmRevertAction = !this.confirmRevertAction;
    }
    else if (actionType === ActionType.Reverse) {
      this.confirmReverseAction = !this.confirmReverseAction;
    }
  }

  onClickActionTypeConfirmed(event: MouseEvent, actionType: ActionType): void {
    event.preventDefault();
    event.stopPropagation();

    if (actionType === ActionType.Revert) {
      this.dialogRef.close({revertClaim: true});
    }
    else if (actionType === ActionType.Reverse) {
      this.dialogRef.close({reverseClaim: true});
    }
  }
}
